import baseAPI from '@/api/base';
import { EditEmployeeAddress, GetEmployeeAddress, RegisterEmployeeAddress } from '@/dtos/employee_address.dto';
import {
  DELETE_EMPLOYEE_ADDRESS_URL,
  EDIT_EMPLOYEE_ADDRESS_URL,
  GET_EMPLOYEE_ADDRESS_URL,
  REGISTER_EMPLOYEE_ADDRESS_URL,
  TOGGLE_EMPLOYEE_ADDRESS_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeAddress {
  static getEmployeeAddresses = async (getEmployeeAddress: GetEmployeeAddress): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_ADDRESS_URL, {
      params: getEmployeeAddress,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeAddress = async (
    registerEmployeeAddress: RegisterEmployeeAddress
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_ADDRESS_URL, {
      ...registerEmployeeAddress,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeAddress = async (editEmployeeAddress: EditEmployeeAddress): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_ADDRESS_URL, {
      ...editEmployeeAddress,
    });
    return response;
  };

  static toggleEmployeeAddressIsActive = async (
    editEmployeeAddress: EditEmployeeAddress
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_ADDRESS_IS_ACTIVE_URL,
      {
        ...editEmployeeAddress,
      }
    );
    return response;
  };

  static deleteEmployeeAddress = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_ADDRESS_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeAddress;
